import React from "react"
import { Ellipsis } from "./styles"

const Loader = ({ centered }) => {
  return (
    <Ellipsis centered={centered}>
      <div />
      <div />
      <div />
      <div />
    </Ellipsis>
  )
}

export default Loader
